module.exports = __webpack_public_path__ + "img/Crooked Setting.6b6062e1.png";